/***
 * Created on 2023/12/26
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef, useState} from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import ic_arrow_pagination_next_svg from "../../static/img/utils/ic-arrow-pagination-next.svg";
import ic_valid_outline_svg from "../../static/img/utils/ic-valid-outline.svg";
import ic_error_outline_svg from "../../static/img/utils/ic-error-outline.svg";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";

function EmailChangeRow({user, t, setUpdatedUser, org, modalRef}) {
    const [showCard, setShowCard] = useState(false);
    const [showUpdateButton, setShowUpdateButton] = useState(false);
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    const {OrganizationAPI} = useOrganizationApi();

    const onMouseOverCard = (e) => setShowCard(true);
    const onMouseOutCard = (e) => setShowCard(false);

    const onMouseOverUpdate = (e) => setShowUpdateButton(true);
    const onMouseOutUpdate = (e) => setShowUpdateButton(false);

    const onMouseOverRemove = (e) => setShowRemoveButton(true);
    const onMouseOutRemove = (e) => setShowRemoveButton(false);

    const accept_update = async () => {
        try {
            await OrganizationAPI.put(`organization/${org.organization_id}/user/${user.id}/email`)
            setUpdatedUser(prev => ([...prev, {action: 'accept', id: user.id}]));
        } catch (err) {
            console.log(err);
            if (err?.response) {
                modalRef.current.alert(true, 'error', err.response.data.code, err.response.data.message);
            }
            else {
                modalRef.current.alert(true, 'error', err.code, err.message);
            }
        }
    }

    const reject_update = async () => {
        try {
            await OrganizationAPI.delete(`organization/${org.organization_id}/user/${user.id}/email`)
            setUpdatedUser(prev => ([...prev, {action: 'reject', id: user.id}]));
        } catch (err) {
            console.log(err);
            modalRef.current.alert(true, 'error', err.response.data.code, err.response.data.message);
        }
    }

    return (

        <div className="email-address-row"
             onMouseOver={onMouseOverCard}
             onMouseOut={onMouseOutCard}
        >
            <div className="email-address-row__inner">
                <div className="email-address-row__email">
                    <div className="email-address-row__email__old">{user.email_changed.old_email}</div>
                    <div className="email-address-row__email__arrow">
                        <img src={ic_arrow_pagination_next_svg} alt="" />
                    </div>
                    <div className="email-address-row__email__new">{user.email_changed.new_email}</div>
                </div>
                <div className={`email-address-row__action ${showCard ? 'is-open': ''}`}>
                    <div className="email-address-row__action__inner">
                        <div className="q-btn-group">
                            <button
                                className="q-btn q-btn-default q-btn-round-corner q-btn-with-icon q-btn-small"
                                onMouseOver={onMouseOverUpdate}
                                onMouseLeave={onMouseOutUpdate}
                                onClick={accept_update}>
                                <img src={ic_valid_outline_svg} className="ic" alt=""/>
                                <span>{`${showUpdateButton ? t('@Update to New Email@') : t('@Update@')}`}</span>
                            </button>
                            <button
                                className="q-btn q-btn-default q-btn-round-corner q-btn-with-icon q-btn-small"
                                onMouseOver={onMouseOverRemove}
                                onMouseLeave={onMouseOutRemove}
                                onClick={reject_update}>
                                <img src={ic_error_outline_svg} className="ic" alt="" />
                                <span>{`${showRemoveButton ? t('@Remove from Organization@') : t('@Remove@')}`}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function EmailChangedDialog({isOpenDialog, onClose, emailChangedUsers, doRefresh, org, hideCancel}) {
    const {t} = useTranslation();
    const modal = useRef();
    const [updatedUsers, setUpdatedUsers] = useState([]);

    const closeModal = () => {
        if (updatedUsers?.length > 0) {
            if (typeof doRefresh === 'function') {
                doRefresh(updatedUsers);
            }
            else {
                window.location.reload();
            }
        }
        onClose();
    }

    useEffect(() => {
        if (updatedUsers.length === emailChangedUsers.length) {
            modal?.current?.setShowSubmit(true);
            modal?.current?.setShowCancel(false);
        }
        else {
            modal?.current?.setShowSubmit(false);
        }
        if (hideCancel) {
            modal?.current?.setShowCancel(false);
        }
    }, [updatedUsers?.length]);

    return (
        <ModalComponent isOpen={isOpenDialog} onClose={closeModal} onSubmit={closeModal} title={t('@Email Address Changed@')} modalSize={'large'} okText={'OK'} ref={modal}>
            <div className="dialog-content">
                <div className="text-wrap !mb-24">
                    {t('@Someone has changed the email address associated with the QNAP ID. If you have any concerns or wish to take action, please review the details below and choose the appropriate option:@')}
                </div>

                <div className="email-address-changed-list">
                    {emailChangedUsers?.filter(u => !updatedUsers.map(u=>u.id).includes(u.id)).map(user => <EmailChangeRow user={user} t={t} setUpdatedUser={setUpdatedUsers} org={org} modalRef={modal} key={user.id}/>)}
                </div>

            </div>
        </ModalComponent>
    );
}

export default EmailChangedDialog;